<script setup>
import { reactive } from "vue";

const props = defineProps({
  data: {
    type: Object,
    required: false,
  },
  apiUrl: {
    type: String,
    required: true,
  },
  backend: {
    type: Object,
    required: true,
  },
});

//const isLocal = window.location.href.indexOf("localhost");

let tempAdd = "";

let page = reactive({
  current: "register",
});

function register() {
  if (tempAdd.indexOf("@") == -1) return;

  props.backend.register(tempAdd).then(() => {
    page.current = "sent";
  });
}

function local() {
  props.backend.register("local").then(() => {
    page.current = "localok";
    localStorage.setItem("token", "local");
  });
}
</script>

<template>
  <div id="register-window">
    <div class="vertical-span-row">

      <div class="home-header">
        <div class="tvain-logo">
          <a href="/"><img src="/images/tvain-logo.png" class="logo" border="0" /></a>
        </div>
      </div>

      <div class="intro-text ui-container">

        <div class="tabbed">
          <input type="radio" id="tab1a" name="css-tabs" checked />
          <input type="radio" id="tab2a" name="css-tabs" />
          <input type="radio" id="tab3a" name="css-tabs" />
          <input type="radio" id="tab4a" name="css-tabs" />

          <ul class="tabs">
            <li class="tab noselect"><label for="tab1a">What is it?</label></li>
            <li class="tab noselect"><label for="tab2a">Sign up!</label></li>
            <li class="tab noselect"><label for="tab3a">Contact</label></li>
            <li class="tab noselect"><label for="tab4a">Privacy</label></li>
          </ul>

          <div class="tab-content">
            <div class="intro">
              <p>
                TvainB is a nodes &amp; noodles style creative tool for creating interactive fiction or for
                prototyping branching narratives and world models. The focus
                is on creating clean, easy to parse data that can easily be used in
                multiple places.
              </p>
              <p>
                The data format is mostly cast in stone. Work currently is on UX
                improvements.
              </p>
              <p>
                It is provided here as a convenience, but if you plan to use it
                for serious projects, please consider self hosting once the
                source is available as the security here is quite barebones.
              </p>
            </div>
          </div>

          <div class="tab-content">
            <div v-if="page.current == 'register'">
              <div class="intro">
                <p>
                  We use a magic link login system. If you already have one, you
                  can find it in your emails, otherwise enter your email below
                  to send/resend you your magic link.
                </p>
              </div>
              <div class="ui-controls register">
                <div class="ui-form-textinput">
                  <div class="ui-label">Email address</div>
                  <input type="text" v-model="tempAdd" v-on:keyup.enter="register()" />
                </div>
                <div>
                  <button class="ui-button ui-button-green" @click="register()">
                    Send me my link!
                  </button>
                </div>
              </div>
              <div class="intro" v-if="2 == 5">
                <p>
                  Looks like you are running the app locally. If you want to
                  only run it like this, you can just skip the whole
                  registration and run on the local account.
                </p>
                <div>
                  <button class="ui-button ui-button-green" @click="local()">
                    Local only!
                  </button>
                </div>
              </div>
              <div>&nbsp;</div>
            </div>
            <div v-if="page.current == 'sent'">
              <div class="intro">
                <p><b>Sent!</b></p>
                <p>
                  An email has been sent to <b>{{ tempAdd }}</b> with a unique
                  link you can use to access your projects. If you lose this,
                  you can always come back here to have it resent to you.
                </p>
              </div>
              <div class="ui-controls register"></div>
            </div>
            <div v-if="page.current == 'localok'">
              <div class="intro">
                <p><b>Local set!</b></p>
                <p>
                  You will now use a single local signon. To "forget" this
                  setting, you can find the option in the Settings window.
                </p>
              </div>
              <div class="ui-controls register"></div>
            </div>
          </div>

          <div class="tab-content">
            <div class="intro">
              <p>
                For support or any question, pop a mail to contact@tvain-b.ink
                and I will get back to you soon as I am able.
              </p>
            </div>
          </div>

          <div class="tab-content">
            <div class="intro">
              <p>Our cookie policy:</p>
              <p><img src="/images/cookies.gif" loading="lazy" /></p>
              <p>
                This site does not use cookies for anything at all and has no
                form of user telemetry.
              </p>
            </div>
          </div>

          <div class="slideshow">
            <img src="/images/screenshot1.png" alt="Image 1">
            <img src="/images/screenshot2.png" alt="Image 2">
            <img src="/images/screenshot3.png" alt="Image 3">
            <img src="/images/screenshot4.png" alt="Image 4">
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
